/* Update odds
**************************************************************/
let updatesInterval = 60 * 1000 * 5;

function updateOdds() {
  let matches = document.querySelectorAll(`[data-match]`);
  let ids = [];
  for (let i = 0; i < matches.length; i++) {
    let id = matches[i].getAttribute("data-match");
    ids.push(id);
  }

  $.ajax({
    type: "POST",
    url: themeVars.adminUrl,
    data: {
      action: "update_odds",
      ids: ids,
    },
  })
    .done(function(result) {
      Object.entries(result).forEach(([id, data]) => {
        Object.entries(data).forEach(([type, value]) => {
          let bets = document.querySelectorAll(`[data-coef='${id}.${type}']`);
          let odds = document.querySelectorAll(
            `[data-odds-attr='${id}.${type}']`
          );
          if (odds.length > 0) {
            for (let j = 0; j < bets.length; j++) {
              if (bets[j] !== null) {
                switch (true) {
                  case bets[j].innerHTML > value.odds:
                    bets[j].classList.add("odd-card__bet-coef_red");
                    break;
                  case bets[j].innerHTML < value.odds:
                    bets[j].classList.add("odd-card__bet-coef_green");
                    break;
                  case bets[j].innerHTML === value.odds:
                    bets[j].classList.remove("odd-card__bet-coef_green");
                    bets[j].classList.remove("odd-card__bet-coef_red");
                    break;
                }
              }
            }
            for (let i = 0; i < odds.length; i++) {
              odds[i].getElementsByTagName("SPAN")[0].innerHTML = value.odds;
            }
          }
        });
      });
    })
    .fail(function() {
    })
    .always(function() {
      // Schedule the next request after this one completes,
      // even after error
      setTimeout(updateOdds, updatesInterval);
    });
}
setTimeout(updateOdds, updatesInterval);

/* Get odds
**************************************************************/
let content = document.querySelector(`#content`);
let page = content !== null ? content.getAttribute("data-page") : "";

let oddsContainer = $(".odd__container");
let gameID = oddsContainer.attr("data-game");
let game = gameID ? JSON.parse(gameID) : "";
let day = document.querySelector(".btn-load.active").getAttribute("data-view");

function getOdds(day) {
  $.ajax({
    type: "POST",
    url: themeVars.adminUrl,
    data: {
      action: "load_odds",
      game: game,
      day: day,
    },
    beforeSend: function() {
      $(".odd_games").removeClass("active");
      oddsContainer.empty();
    },
    success: function(result) {
      oddsContainer.html(result);
      if ($.trim(result)) {
        $(".odd_games").addClass("active");
      }
    },
  });
}

page === 'game' ? getOdds(day) : '';

export { getOdds };



// WEBPACK FOOTER //
// ./scripts/modules/Ajax-odds.js